import { render, staticRenderFns } from "./TreatmentAmount.vue?vue&type=template&id=5bfe154d&scoped=true&lang=pug&"
import script from "./TreatmentAmount.vue?vue&type=script&lang=js&"
export * from "./TreatmentAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe154d",
  null
  
)

export default component.exports